<template>
  <v-select @input="pictureLibSelected" :options="paginatedPictureLibraries" label="name" placeholder="Select Picture Library">
    <template slot="option" slot-scope="option">
      <show-image style="width:80px;" :src="option.file" />
      {{ option.name }}
    </template>
    <li slot="list-footer" class="mx-3 " >
      <b-button type="is-dark" @click="current_picture_library_page -= picture_library_page_items" :disabled="!hasPrevPagePictureLibrary">Prev</b-button>
      <b-button type="is-dark" @click="current_picture_library_page += picture_library_page_items" :disabled="!hasNextPagePictureLibrary">Next</b-button>
    </li>
  </v-select>
</template>
<script>
import {mapGetters, mapActions} from 'vuex'
import ShowImage from "@/components/General/ShowImage"
export default {
  name : 'picture-library-select',
  components : {
    ShowImage
  },
  props : {
    value : {
      type : String
    }
  },
  data(){
    return {
      pl_id : this.value,
      current_picture_library_page: 0,
      picture_library_page_items: 25,
    }
  },
  methods : {
    ...mapActions(['loadPictureLibraries']),
    pictureLibSelected(val){
      if(val){
        this.pl_id = val._id
      }else{
        this.pl_id = null
      }

      // Now Emitting
      this.$emit('input', this.pl_id)
    }
  },
  computed : {
    ...mapGetters(['getTeacherToken', 'fetchPictureLibraries']),
    paginatedPictureLibraries () {
      return this.fetchPictureLibraries.slice(this.current_picture_library_page, this.picture_library_page_items + this.current_picture_library_page);
    },
    hasNextPagePictureLibrary () {
      const nextOffset = this.current_picture_library_page + 10;
      return Boolean(this.fetchPictureLibraries.slice(nextOffset, this.picture_library_page_items + nextOffset).length);
    },
    hasPrevPagePictureLibrary () {
      const prevOffset = this.current_picture_library_page - 10;
      return Boolean(this.fetchPictureLibraries.slice(prevOffset, this.picture_library_page_items + prevOffset).length);
    }
  },
  watch : {
    value : function(new_val){
      this.pl_id = new_val
    }
  },
  created(){
    this.loadPictureLibraries({
      token : this.getTeacherToken
    })
  }
}
</script>